import CUSTOMER_MUTATIONS from "./roles/customer/mutations";
export default {
  SAVE_ACCESS_TOKEN(state, payload) {
    state.access_token = payload;
  },
  SAVE_REFRESH_TOKEN(state, payload) {
    state.refresh_token = payload;
  },
  SAVE_USER_DATA(state, payload) {
    state.user = payload;
  },
  SAVE_FINGERPRINT(state, payload) {
    state.fingerprint = payload;
  },
  SAVE_SYSTEM_INFO(state, payload) {
    state.systemInfo = payload;
  },
  SAVE_ACCOUNT_ID(state, payload) {
    state.accountID = payload;
  },
  SAVE_USERNAME(state, payload) {
    state.username = payload;
  },

  SAVE_PROFILE(state, payload) {
    state.profile = payload || {};
  },
  SAVE_PREFERRED_CRYPTO(state, payload) {
    state.preferredCrypto = payload || "btc";
  },
  SAVE_SECURE(state, payload) {
    state.secure = payload || {};
  },
  ...CUSTOMER_MUTATIONS,
};
